import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySuppliersOrdersRoutes: MenuInterface[] = [
    {
        code: 'NewSupplierOrder',
        route: [
            {
                content: '$type/suppliers/orders/new',
                focus: '$type/suppliers/orders/new/detail'
            },
            'content',
        ],
    },
    {
        code: 'SupplierOrdersList',
        route: [
            {
                content: '$type/suppliers/orders/list',
                focus: 'empty',
            }, 'content'
        ]
    },
];
